import { ArrowLeftOutlined, ArrowRightOutlined } from '@ant-design/icons';
import { setSelectedClient } from '@app/store/slices/userSlice';
import { AuthWrap } from '@FW/components/Forms/Auth/AuthWrap.styled';
import ChangeLanguage from '@FW/components/Language/LanguageRadio/ChangeLanguage';
import { Client } from '@interfaces/FW/Client';
import { useAppDispatch, useAppSelector } from '@shared/hooks/reduxHooks';
import { Button, Flex, Typography } from 'antd';
import Title from 'antd/es/typography/Title';
import { t } from 'i18next';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const { Text } = Typography;

export const SelectClientForm = () => {
	const { allClients } = useAppSelector((state) => state.user);
	const dispatch = useAppDispatch();
	const navigate = useNavigate();

	const handleSelectClient = (client: Client) => {
		dispatch(setSelectedClient(client));
		navigate('/');
	};

	return (
		<Flex vertical gap={16} className='w-full'>
			<AuthWrap>
				<Button onClick={() => navigate('/auth/login')}>
					<ArrowLeftOutlined /> {t('passwordRecovery.passwordRecoveryReturn')}
				</Button>

				<Title level={3}>{t('auth.selectClientTitle')}</Title>
				<Text className='text-gray'>{t('auth.selectClientDescription')}</Text>

				<Flex gap={16} vertical>
					{allClients?.map((client) => (
						<SelectClientButton
							type='text'
							key={client.counterparty}
							className='w-full'
							onClick={() => handleSelectClient(client)}
						>
							<Flex vertical gap={4} className='w-full left-content' justify='flex-start'>
								<Text className='block-title'>{client.counterpartyName}</Text>
								<Text className='description'>{client.codeEgrpou}</Text>
							</Flex>
							<ArrowRightOutlined />
						</SelectClientButton>
					))}
				</Flex>
			</AuthWrap>
			<ChangeLanguage />
		</Flex>
	);
};

const SelectClientButton = styled(Button)`
	height: max-content;
	justify-content: space-between;
	gap: 16px;
	width: 100% !important;
	background-color: #eef6f2 !important;

	.left-content {
		padding: 8px 0;
	}

	span {
		text-align: start;
	}

	.description {
		color: var(--gray);
	}
`;